import { render, staticRenderFns } from "./CardTemplateGreenfox.vue?vue&type=template&id=22cd9e66&scoped=true&"
import script from "./CardTemplateGreenfox.vue?vue&type=script&lang=js&"
export * from "./CardTemplateGreenfox.vue?vue&type=script&lang=js&"
import style0 from "./CardTemplateGreenfox.vue?vue&type=style&index=0&id=22cd9e66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cd9e66",
  null
  
)

export default component.exports